export default __webpack_public_path__ + "static/media/sublevel2_2.abddd102.webp";